import { CMSComponent, type CMSComponentProps } from "../engine/CMSComponent.tsx";
import { isCMSNode } from "../types.ts";

const str = (value: unknown) => (typeof value === "string" ? value : undefined);

export function MediaFrame({ node }: CMSComponentProps) {
  const ratio = str(node.mediaRatio)?.replace(":", " / ");
  return (
    <div
      className={`cms-media ${node.roundedCorners === false ? "" : "cms-media--rounded"}`}
      style={ratio ? { aspectRatio: ratio } : undefined}
    >
      <CMSComponent node={node.video ?? node.image} />
    </div>
  );
}

export function Image({ node }: CMSComponentProps) {
  const base = str(node.baseImage);
  const md = str(node.mdImage);
  const desktop = str(node.desktopImage);
  if (!base) return null;

  return (
    <picture className="cms-image">
      {desktop && <source media="(min-width: 1024px)" srcSet={desktop} />}
      {md && <source media="(min-width: 640px)" srcSet={md} />}
      <img src={base} alt={str(node.imageAltText) ?? ""} loading="lazy" decoding="async" />
    </picture>
  );
}

const videoSources = (collection: unknown) =>
  Array.isArray(collection)
    ? collection.filter(isCMSNode).map((item) => ({
        src: str(item.src),
        type: str(item.type),
      }))
    : [];

export function Video({ node }: CMSComponentProps) {
  const sources = videoSources(node.mdVideoCollection).length
    ? videoSources(node.mdVideoCollection)
    : videoSources(node.baseVideoCollection);

  return (
    <video
      className="cms-video"
      poster={str(node.imageUrlDesktop)}
      aria-label={str(node.altTextDesktop)}
      autoPlay={node.autoplay === true}
      loop={node.loop === true}
      muted
      playsInline
      preload="metadata"
    >
      {sources.map((source) => (
        <source key={source.src} src={source.src} type={source.type} />
      ))}
    </video>
  );
}
